import { ProductTour } from 'components/ProductTour/ProductTour'
import { Step } from 'walktour'
import { TourProps, TourStartCard } from '../Types'
import { getScrollParent } from '@react-aria/utils'

const steps: Step[] = [
  {
    selector: '.social-media-doc-tour-1',
    title: 'Edit Your Post',
    description: "Fine tune the text of your post until it's perfect.",
  },
  {
    selector: '.social-media-doc-tour-2',
    title: 'Add Images or Video',
    description: "Add or change your post's videos and images.",
  },
  {
    selector: '.social-media-doc-tour-3',
    title: 'Choose How to Post',
    description: 'Schedule your content to post automatically on this social media site.',
  },
  {
    selector: '.social-media-doc-tour-4',
    title: 'Turn Into New Content',
    description: 'Transform this post into a newsletter, video script, or many other types of content.',
  },
]

const startCard: TourStartCard = {
  title: 'Supercharge your social media',
  content: 'Plan, create and auto-post content across all platforms.',
}

const beforeStart = () => {
  const scrollToTop = (el: HTMLElement | null) => {
    if (el) {
      const scrollParent = getScrollParent(el)
      if (scrollParent) {
        scrollParent.scrollTop = 0
      }
    }
  }

  scrollToTop(document.querySelector('.social-media-doc-tour-2'))
  scrollToTop(document.querySelector('.social-media-doc-tour-4'))
}

export const SocialMediaDocTour = (props: TourProps) => {
  return (
    <ProductTour tour="social_media_doc" steps={steps} {...props} startCard={startCard} beforeStart={beforeStart} />
  )
}
